module.exports = __webpack_public_path__ + "img/gBalm4.dc829c2d.jpg";